/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { dashboard, doctor, menuicon04, menuicon06, menuicon10, patients, uploadfile } from './imagepath';
import Scrollbars from "react-custom-scrollbars-2";
import { useAuth } from '../contexts/AuthContext';


const Sidebar = (props) => {
  const [sidebar, setSidebar] = useState("");
  const { user } = useAuth();

  const userRole = user?.role || 'STAFF';
  const isPatient = userRole === 'PATIENT';
  const isDoctor = userRole === 'DOCTOR';
  const isAdmin = userRole === 'ADMIN';
  const isAdminOrStaff = userRole === 'ADMIN' || userRole === 'STAFF';
  
  const handleClick = (e, item, item1, item3) => {
    const div = document.querySelector(`#${item}`);
    const ulDiv = document.querySelector(`.${item1}`);

    if (!div || !ulDiv) return;

    // Check current display state to toggle properly
    const isCurrentlyOpen = ulDiv.style.display === 'block' || getComputedStyle(ulDiv).display === 'block';

    if (isCurrentlyOpen) {
      ulDiv.style.display = 'none';
      div.classList.remove('subdrop');
    } else {
      ulDiv.style.display = 'block';
      div.classList.add('subdrop');
    }
  }

  useEffect(() => {
    if (props?.id && props?.id1) {
      const ele = document.getElementById(`${props?.id}`);
      const ulEle = document.querySelector(`.${props?.id1}`);
      if (ele && ulEle) {
        handleClick(ele, props?.id, props?.id1);
      }
    }
  }, [])


  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const closeMobileSidebar = () => {
    // Close mobile sidebar when link is clicked
    document.body.classList.remove("slide-nav");
    document.getElementsByTagName("html")[0].classList.remove('menu-opened');
    const overlay = document.getElementsByClassName("sidebar-overlay")[0];
    if (overlay) {
      overlay.classList.remove("opened");
    }
  };

  return (
    <>
      <div className="sidebar" id="sidebar">
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu"
              onMouseLeave={expandMenu}
              onMouseOver={expandMenuOpen}
            >
              <ul>
                <li className="menu-title">Main</li>

                {/* Dashboard - direct link based on role (patients go to telechat instead) */}
                {!isPatient && (
                  <li>
                    <Link
                      to={isDoctor ? "/doctor-dashboard" : "/admin-dashboard"}
                      className={props?.activeClassName === 'admin-dashboard' || props?.activeClassName === 'doctor-dashboard' ? 'active' : ''}
                      onClick={closeMobileSidebar}
                    >
                      <span className="menu-side">
                        <img src={dashboard} alt="" />
                      </span>{" "}
                      <span> Табло </span>
                    </Link>
                  </li>
                )}

                {/* Doctors - visible to ADMIN, STAFF only */}
                {isAdminOrStaff && (
                  <li className="submenu">
                    <Link to="#" id="menu-item1" onClick={(e) => {
                      handleClick(e, "menu-item1", "menu-items1")
                    }}>
                      <span className="menu-side">
                        <img src={doctor} alt="" />
                      </span>{" "}
                      <span> Лекари </span>
                    </Link>
                    <ul style={{ display: sidebar === 'Doctors' ? 'block' : 'none' }} className="menu-items1">
                      <li>
                        <Link className={props?.activeClassName === 'doctor-list' ? 'active' : ''} to="/doctors" onClick={closeMobileSidebar}>Списък лекари</Link>
                      </li>
                      <li>
                        <Link className={props?.activeClassName === 'add-doctor' ? 'active' : ''} to="/doctors/add" onClick={closeMobileSidebar}>Добави лекар</Link>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Patients - visible to ADMIN, DOCTOR */}
                {(isAdmin || isDoctor) && (
                  <li className={isAdmin ? "submenu" : ""}>
                    {isAdmin ? (
                      <>
                        <Link to="#" id="menu-item2" onClick={(e) => handleClick(e, "menu-item2", "menu-items2")}>
                          <span className="menu-side">
                            <img src={patients} alt="" />
                          </span>{" "}
                          <span>Пациенти </span>
                        </Link>
                        <ul style={{ display: "none" }} className="menu-items2">
                          <li>
                            <Link className={props?.activeClassName === 'patient-list' ? 'active' : ''} to="/patients" onClick={closeMobileSidebar}>Списък пациенти</Link>
                          </li>
                          <li>
                            <Link className={props?.activeClassName === 'add-patient' ? 'active' : ''} to="/patients/add" onClick={closeMobileSidebar}>Добави пациент</Link>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <Link to="/patients" className={props?.activeClassName === 'patient-list' ? 'active' : ''} onClick={closeMobileSidebar}>
                        <span className="menu-side">
                          <img src={patients} alt="" />
                        </span>{" "}
                        <span>Пациенти</span>
                      </Link>
                    )}
                  </li>
                )}

                {/* Visits - visible to ADMIN, STAFF only */}
                {isAdminOrStaff && (
                  <li className="submenu">
                    <Link to="#" id="menu-item4" onClick={(e) => handleClick(e, "menu-item4", "menu-items4")}>
                      <span className="menu-side">
                        <img src={menuicon04} alt="" />
                      </span>{" "}
                      <span> Прегледи </span>
                    </Link>
                    <ul style={{ display: "none" }} className="menu-items4">
                      <li>
                        <Link className={props?.activeClassName === 'visits-history' ? 'active' : ''} to="/visits" onClick={closeMobileSidebar}>Списък прегледи</Link>
                      </li>
                      <li>
                        <Link className={props?.activeClassName === 'visit-form' ? 'active' : ''} to="/visits/new" onClick={closeMobileSidebar}>Нов преглед</Link>
                      </li>
                    </ul>
                  </li>
                )}

                {/* Upload XML - visible to ADMIN, STAFF only */}
                {isAdminOrStaff && (
                  <li>
                    <Link to="/upload-xml" className={props?.activeClassName === 'upload-xml' ? 'active' : ''} onClick={closeMobileSidebar}>
                      <span className="menu-side">
                        <img src={uploadfile} alt="" />
                      </span>{" "}
                      <span> Зареди файл </span>
                    </Link>
                  </li>
                )}

                {/* AI Assistant - visible to ADMIN, STAFF only */}
                {isAdminOrStaff && (
                  <li>
                    <Link to="/ai-assistant" className={props?.activeClassName === 'ai-assistant' ? 'active' : ''} onClick={closeMobileSidebar}>
                      <span className="menu-side">
                        <img src={menuicon06} alt="" />
                      </span>{" "}
                      <span> AI Асистент </span>
                    </Link>
                  </li>
                )}

                {/* Telemedicine - different view for each role */}
                <li className={isPatient ? "" : "submenu"}>
                  {isPatient ? (
                    // Patient sees direct link to their consultations
                    <Link to="/telechat" className={props?.activeClassName === 'telechat' ? 'active' : ''} onClick={closeMobileSidebar}>
                      <span className="menu-side">
                        <img src={menuicon10} alt="" />
                      </span>{" "}
                      <span> Моите консултации </span>
                    </Link>
                  ) : isDoctor ? (
                    // Doctor sees direct link to their consultations
                    <Link to="/doctor/telechat" className={props?.activeClassName === 'doctor-telechat' ? 'active' : ''} onClick={closeMobileSidebar}>
                      <span className="menu-side">
                        <img src={menuicon10} alt="" />
                      </span>{" "}
                      <span> Моите консултации </span>
                    </Link>
                  ) : (
                    // Admin/Staff sees submenu with both views
                    <>
                      <Link to="#" id="menu-item5" onClick={(e) => handleClick(e, "menu-item5", "menu-items5")}>
                        <span className="menu-side">
                          <img src={menuicon10} alt="" />
                        </span>{" "}
                        <span> Телемедицина </span>
                      </Link>
                      <ul style={{ display: "none" }} className="menu-items5">
                        <li>
                          <Link className={props?.activeClassName === 'telechat' ? 'active' : ''} to="/telechat" onClick={closeMobileSidebar}>Консултации (Пациент)</Link>
                        </li>
                        <li>
                          <Link className={props?.activeClassName === 'doctor-telechat' ? 'active' : ''} to="/doctor/telechat" onClick={closeMobileSidebar}>Консултации (Лекар)</Link>
                        </li>
                      </ul>
                    </>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  )
}
export default Sidebar
